<main
  class="backend-not-found d-flex align-items-center justify-content-center"
>
  <section class="backend-not-found-card">
    <p class="backend-not-found-code">404</p>
    <h1 class="backend-not-found-title">Page Not Available</h1>
    <p class="backend-not-found-copy">
      We are unable to load this page right now.
    </p>
    <p class="backend-not-found-hint">
      Please try again in a moment. If the problem continues, contact support.
    </p>
    <button class="backend-not-found-button" type="button" @click="retry">
      Try Again
    </button>
  </section>
</main>
